<template>
  <div class="dashboard">
    <Tile :title="tile.title" :tileId="tile.id" :path="tile.path" :icon="tile.icon" v-for="(tile, index) in tiles" :key="tile.id" :order="index" :rules="tile.rules" :startUpAnimation="false" :width="33.3">
      <component v-show="tile.loaded" :is="tile.component" v-bind="Object.assign(tile.settings, {id: tile.id})" @loaded="tile.loaded = true"></component>
      <LoadingScreen v-if="!tile.loaded" :expectedHeight="tile.expectedHeight" />
    </Tile>
  </div>
</template>

<script>
import { auth, storage } from "../schmucklicloud";
import States from "../states";

export default {
  data() {
    return {
      tiles: []
    };
  },
  computed: {
    isEditMode() {
      return States.main_editmode;
    }
  },
  mounted() {
    var session_token = window.localStorage.getItem("session_token");
    auth.checkSession(session_token).then(function(response){
      if (response.isOK) {
        storage.setAuthToken(session_token);
        this.loader();
      } else {
        this.$router.replace("/login");
      }
    }.bind(this));
  },
  methods: {
    loader() {
      storage.getAll("tiles").then(function (response) {
        if(response.isOK) {
          response.data.sort(function (a, b) {
            return a.data.order - b.data.order;
          });

          response.data.forEach(function(tile){
              if(tile.data.settings === undefined) {
                tile.data.settings = "{}";
              }
              if(tile.data.rules === undefined) {
                tile.data.rules = "[]";
              }

              //Rule checking if it should display certain tiles
              var rules = JSON.parse(tile.data.rules);
              if(rules.length !== 0) {
                var rule_matched = 0;

                var rule_counter = 0;
                rules.forEach(async function(rule) {
                  switch (rule.type) {
                    case "time":
                      var currentHour = (new Date()).getHours();
                      if (rule.time.from <= currentHour && rule.time.to > currentHour) {
                        rule_matched++;
                      }
                      break;
                    case "location":
                      if (navigator.geolocation) {
                        var location = await this.getCurrentPosition();
                        var lat = location.coords.latitude;
                        var lon = location.coords.longitude;

                        if (this.checkLocation({
                          lat: lat,
                          lng: lon
                        }, {
                          lat: rule.location.lat,
                          lng: rule.location.lon
                        }, rule.location.radius)) {
                          rule_matched++;
                        }

                      } else {
                        rule_matched++;
                      }
                      break;
                  }

                  // Validates if all rules has been applied
                  rule_counter++;
                  if(rules.length === rule_counter) {
                    var rule_settings = JSON.parse(tile.data.rule_settings);
                    var rule_match_type = rule_settings.match_type || 'one';
                    switch (rule_match_type) {
                      case 'one':
                        if (rule_matched > 0) {
                          this.addTile(tile);
                        } 
                        break;
                      case 'all':
                        if (rule_matched === rules.length) {
                          this.addTile(tile);
                        } 
                        break;
                    }
                  }
                }.bind(this));
              } else {
                this.addTile(tile);
              }
          }.bind(this));
        }
      }.bind(this));
    },

    addTile(tile) {
      this.$set(this.tiles, this.tiles.length, {
        id: tile.id,
        title: tile.data.title,
        order: tile.data.order,
        loaded: false,
        icon: tile.data.icon,
        path: tile.data.path,
        expectedHeight: tile.data.expectedHeight,
        rules: JSON.parse(tile.data.rules),
        settings: JSON.parse(tile.data.settings),
        component: function () {
          return import("@/tiles/" + tile.data.path);
        }
      });
      this.sortTiles();
    },

    sortTiles() {
      this.tiles.sort(function(a, b) {
        if (a.order < b.order)
          return -1;
        if (a.order > b.order)
          return 1;
        return 0;
      })
    },

    getCurrentPosition(options = {}) {
      return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, options);
      });
    },

    checkLocation(checkPoint, centerPoint, km) {
      var ky = 40000 / 360;
      var kx = Math.cos(Math.PI * centerPoint.lat / 180.0) * ky;
      var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
      var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
      return Math.sqrt(dx * dx + dy * dy) <= km;
    }
  }
};
</script>

<style>
.dashboard {
    display: flex;
    flex-flow: row wrap;
    padding: 0 3px 0 3px;
    align-items: flex-start;
    justify-content: center;
    max-height: 74vh;
    overflow-x: auto;
}
</style>